export function sortThreadsOldestFirst<T extends { createdAt: string }>(threads: T[]): T[] {
  return [...threads].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );
}

export function getCalendarDayKey(isoDate: string): string {
  const date = new Date(isoDate);
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

export function formatMessageDayLabel(
  createdAt: string,
  todayLabel: string,
  yesterdayLabel: string,
): string {
  try {
    const date = new Date(createdAt);
    const now = new Date();
    const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const startOfNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffDays = Math.round(
      (startOfNow.getTime() - startOfDate.getTime()) / (24 * 60 * 60 * 1000),
    );
    if (diffDays === 0) return todayLabel;
    if (diffDays === 1) return yesterdayLabel;
    if (diffDays > 1 && diffDays < 7) {
      return date.toLocaleDateString(undefined, { weekday: 'short' });
    }
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return '';
  }
}
